export default __webpack_public_path__ + "static/media/metamask.d432eb7a.svg";